module.exports = __webpack_public_path__ + "static/media/Decisions_Step3_Image7.eb899b96.jpg";